import { render, staticRenderFns } from "./refresh-button.component.vue?vue&type=template&id=6c36a523"
import script from "./refresh-button.component.vue?vue&type=script&lang=js"
export * from "./refresh-button.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports